import React from "react";
import styled from "styled-components";

import Header from "./Header";
import Footer from "./Footer";

import "bootstrap/dist/css/bootstrap.css";

const WRAPPER = styled.div`
  height: 100%;
  overflow-y: auto;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;

  display: flex;
  flex-direction: column;
`;

const BACKGROUND = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
`;

const CONTAINER = styled.div`
  flex: 1;
  margin: 0 auto;
  max-width: 75%;
  padding: 15px;
`;

export const SECTION = styled.div`
  margin-top: 50px;
`;

export const ROW = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: row;
`;

export const HEADING = styled.h1`
  font-size: 30pt;
  font-weight: 700;
  color: #fff;
`;

export const TAGLINE = styled.p`
  font-size: 16pt;
  font-weight: 400;
  color: #fff;
`;

export const CONTENT = styled.p`
  font-size: 16pt;
  font-weight: 400;
  color: #fff;
`;

export const LABEL = styled.label`
  font-size: 16pt;
  font-weight: 400;
  color: #fff;
`;

export const CONTENT_LI = styled.li`
  font-size: 16pt;
  font-weight: 400;
  color: #fff;
`;

export const TEXT = styled.span`
  color: #40b1e8;
  font-weight: 700;
`;

const Page = ({ children }) => {
  return (
    <WRAPPER>
      <style>{`
        html, body {
          margin: 0;
          padding: 0;
          overflow: hidden;
          font-family: "Barlow", system-ui, -apple-system, sans-serif;
          background-color: #0f2027;
        }
      `}</style>
      <BACKGROUND />

      <CONTAINER className="container">
        <Header title={"Home"} />

        <img
          src="/img/securewebsolutions_web.png"
          alt="Secure Web Solutions LLC, McHenry IL Software Company"
          style={{
            width: "280px",
            filter:
              "drop-shadow(0px 0px 4px rgba(255, 255, 255, 0.9)) drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.6))",
            marginTop: "15px",
            marginBottom: "15px",
          }}
        />

        <SECTION>{children}</SECTION>

        <Footer />
      </CONTAINER>
    </WRAPPER>
  );
};

export default Page;
